import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { number, func, oneOfType, string, bool } from 'prop-types';
import ButtonWithIcon from 'react/components/ButtonWithIcon';
import {
  departureLocationIcon,
  departureLocationIconActive
 } from 'react/utils/stopDetailsPopupBase64Icons.js';
import {
  enableDepartureLocation,
  disableDepartureLocation,
  addDepartureLocationToMap,
  removeDepartureLocationFromMap
} from 'react/api/actions/stopDetailsPopup';

class DepartureLocationButton extends React.PureComponent {

  componentDidMount() {
    const {
      departureLocationIsEnabled,
      addDepartureLocationToMapAction,
      routeId,
      stopId
    } = this.props;

    if (departureLocationIsEnabled) {
      addDepartureLocationToMapAction(routeId, stopId);
    }
  }

  toggleDepartureLocation = (e) => {
    const {
      departureLocationIsEnabled,
      disableDepartureLocationAction,
      enableDepartureLocationAction,
      addDepartureLocationToMapAction,
      removeDepartureLocationFromMapAction,
      stopId,
      routeId
    } = this.props;
    e.stopPropagation();
    removeDepartureLocationFromMapAction(routeId, stopId);
    if (departureLocationIsEnabled) {
      disableDepartureLocationAction(routeId, stopId);
    } else {
      enableDepartureLocationAction(routeId, stopId);
      addDepartureLocationToMapAction(routeId, stopId);
    }
  }

  render() {
    const { departureLocationIsEnabled, ...others } = this.props;
    return (
      <Fragment>
        <ButtonWithIcon
          label={Monet.I18n.getResourcesByKey('ToolBar.Layers.Departure')}
          isActive={departureLocationIsEnabled}
          iconUrl={departureLocationIcon}
          activeIconUrl={departureLocationIconActive}
          onClick={this.toggleDepartureLocation}
          {...others}
        />
      </Fragment>
    );
  }
}

DepartureLocationButton.propTypes = {
  routeId: oneOfType([string, number]).isRequired,
  stopId: oneOfType([string, number]).isRequired,
  departureLocationIsEnabled: bool.isRequired,
  enableDepartureLocationAction: func.isRequired,
  disableDepartureLocationAction: func.isRequired,
  addDepartureLocationToMapAction: func.isRequired,
  removeDepartureLocationFromMapAction: func.isRequired
};

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  departureLocationIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'departureLocationIsEnabled'], false)
});

const mapDispatchToProps = {
  enableDepartureLocationAction: enableDepartureLocation,
  disableDepartureLocationAction: disableDepartureLocation,
  addDepartureLocationToMapAction: addDepartureLocationToMap,
  removeDepartureLocationFromMapAction: removeDepartureLocationFromMap
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartureLocationButton);
